import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2 w-full max-w-5xl no-last-margin tight-p border-red-700 text-red-800 font-semibold"
}
const _hoisted_2 = { class: "space-y-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasMessages)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(message), 1))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}